import { GetStaticPaths, GetStaticPathsResult, GetStaticProps } from "next";
import facilities from "@/constants/facilities_detail.json";
// import RichSearch from "@/components/common/RichSearch";
import { FUNERAL_SIGUNGU } from "goi_common";
import dayjs from "dayjs";
import { Box } from "@chakra-ui/react";
// import { richSearchData } from "@/constants/richSearch";
import { FacilityRelocateContainer } from "@/containers/MatchContainer";

import { skipDevBuildInGetStaticPaths } from "@/utils/skipDevBuildInGetStaticPaths";
import { getFacilityRegionKeyword } from "@/utils/facilityTypeLabel";

export const getStaticPaths: GetStaticPaths = async () => {
  const skipBuildResult = skipDevBuildInGetStaticPaths() as GetStaticPathsResult;
  if (skipBuildResult) {
    return skipBuildResult;
  }

  const paths = facilities.map((facility) => ({
    params: {
      id: String(facility.id),
    },
  }));

  return {
    paths,
    fallback: false,
  };
};

export const getStaticProps: GetStaticProps = async ({ params }) => {
  const id = params?.id;
  let facility;
  let sigungu;
  let name = "";
  let description = "";
  // 지역과 붙여 쓰는 유형 표기. 유형별로 갈라야 검색 의도가 맞는다 (utils/facilityTypeLabel)
  let regionKeyword = "장지";

  if (id) {
    facility = facilities.find((facility) => String(facility.id) === id);
    if (facility) {
      name = facility.companyname;
      sigungu = FUNERAL_SIGUNGU.get(Number(facility?.sido))?.get(Number(facility?.sigungu));
      regionKeyword = getFacilityRegionKeyword(facility.type);
      description = `${name} 상세 비용 정보와 시설 정보를 안내해드립니다. ${sigungu} 지역에 위치한 ${regionKeyword} 상세 비용 정보와 시설 정보를 비교해드립니다. 고객님의 상황에 알맞는 장지 유형과 추천해드리겠습니다.`;
    }
  }

  return {
    props: {
      defaultFacility: facility,
      pageDescription: description,
      pageKeywords: `${name}, ${name} 가격, ${name} 위치, ${name} 후기, ${name} 정보, 장지검색, 봉안, 자연, 매장, 봉안당, 수목장, 화초장, 잔디장, 매장묘, 납골당, ${sigungu} ${regionKeyword}, ${sigungu} 장지, ${sigungu} ${regionKeyword} 비용, ${regionKeyword} 비용`,
      pageOgTitle: `${name}(${sigungu}) ${regionKeyword} 비용과 견적 - [장례의 모든 것, 고이장례연구소]`,
      pageOgDescription: description,
      pageOgImage: facility?.images[0]?.url || `${process.env.NEXT_PUBLIC_CDN_URL}/ogimage.png`,
    },
  };
};

function FacilityRequest({ defaultFacility }: { defaultFacility: any }) {
  // const { FAQRichSearch } = richSearchData.facilities;
  const today = dayjs().format("YYYY-MM-DD");

  return (
    <>
      <Box position="absolute" marginTop="-90px">
        <time dateTime={today} className="white se_publishDate pcol2 date">
          {today}
        </time>
      </Box>

      {/* <RichSearch key="faqs" data={FAQRichSearch} /> */}
      <FacilityRelocateContainer defaultFacility={defaultFacility} />
    </>
  );
}

export default FacilityRequest;
